import styled from 'styled-components'

export const PageTitleHeader = styled.header`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 8px;
  border: none;
  border-radius: 8px;
  background: #f0f0f0;
  color: #4c4c4c;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;

  svg {
    width: 16px;
    height: 16px;
    font-size: 14px;
  }

  &:hover {
    background: #e0e0e0;
    color: #363636;
  }
`

export const Title = styled.h1`
  margin: 0;
  color: #002a6d;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  white-space: nowrap;
`
